<template lang="pug">
.content-wrap
  .content-top
    .con.p-0
      section.fullBg
        main
          .signin-record-div
            .last-signin
              p(v-if="chkinDate == null") -
              p(v-if="chkinDate != null") {{ $moment(chkinDate).format("YYYY-MM-DD") }}
              p Last sign in
            .divider
            .total-signin-bonus
              p(v-if="isLoggedIn") {{accuReward}}
              p(v-if="!isLoggedIn") -
              p Sign in total bonus
          hr
          .weekly-reward-div
            img(src='/new/img/events/checkin/Box.png' alt='box')
            .content
              p.first-content Sign in weekly and get up to MYR{{totalBonus}}
              .content-div(v-if="todayCheckin == true")
                p.second-content.m-0  Checked in today
                .tooltipc.bg-success(@click="$router.push('/promotions').catch(err => {})")
                  p.m-0 &#x2713;
              .content-div(v-if="todayCheckin == false")
                p.second-content.m-0  Not checked in today
                .tooltipc(@click="$router.push('/promotions').catch(err => {})")
                  p.m-0 ?
          .min-deposit-div.text-black
            p
              | Minimum deposit 
              br
              | amount: 
              span MYR{{minDepo}}
          hr
          .angpao-div(v-if="isLoggedIn")
            .angpao-versions(v-for="(day,index) in progress")
              //- img(:class="{'closed': day.deposit_amount == null, 'opened': day.deposit_amount != null}")
              img.closed(v-if="day.deposit_amount < 200" :src="`/new/img/events/checkin/Day ${index+1} Closed.png`" :alt='`day ${index+1} closed`' @click="openPop(0)")
              img.opened(v-if="day.deposit_amount >= 200" :src="`/new/img/events/checkin/Day ${index+1} Opened.png`" :alt='`day ${index+1} opened`' @click="openPop(1, day.bonus_amount)")
          .angpao-div(v-if="!isLoggedIn")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 1 Closed.png' alt='day 1 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 2 Closed.png' alt='day 2 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 3 Closed.png' alt='day 3 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 4 Closed.png' alt='day 4 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 5 Closed.png' alt='day 5 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 6 Closed.png' alt='day 6 closed' @click="openPop(0)")
            .angpao-versions
              img.closed(src='/new/img/events/checkin/Day 7 Closed.png' alt='day 7 closed' @click="openPop(0)")
          .popup-div.d-flex.pointer(v-if="showReward" @click="toggleReward")
            .popup-contents
              img(:src='`/new/img/events/checkin/P${rewardAmt} Pop Up.png`' alt='pop up')
              .popup-click(@click="toInbox")
          .confirmation-popup-div.d-flex.pointer.text-black(v-if="showGuide" @click="toggleGuide")
            .popup-contents
              h3 Confirmation
              br
              template(v-if="todayCheckin == false")
                p
                  | Please complete the Deposit Requirements for today&apos;s 
                  br
                  | angpao bonus.
                br
                p
                  | Current Deposit Amount: 
                  span(v-if="depoAmt != null") {{depoAmt}}
                  span(v-if="depoAmt == null") {{0}}
                p Required Deposit Amount: 150
                br
                .actions
                  button.cancel(@click="toggleGuide") Cancel
                  button.go(@click="toDepo") GO
              template(v-if="todayCheckin == true")
                template(v-if="rewardAmt != null")
                  p
                    | Please complete the Deposit Requirements for today&apos;s 
                    br
                    | angpao bonus.
                  br
                  p
                    | Current Deposit Amount: 
                    span(v-if="depoAmt != null") {{depoAmt}}
                    span(v-if="depoAmt == null") {{0}}
                  p Required Deposit Amount: 150
                  br
                  .actions
                    button.cancel(@click="toggleGuide") Cancel
                    button.go(@click="openReward()") GO
                template(v-if="rewardAmt == null")
                  p
                    | Please comeback tomorrow and
                    br
                    | claim your next angpao bonus
                  br
                  .actions
                    button.cancel(@click="toggleGuide") OK
</template>
<script>
export default{
  data(){
    return{
      startRender: false,
      progress:[],
      showReward:false,
      showGuide:false,
      rewardAmt:null,
      chkinDate: null,
      accuReward: null,
      todayCheckin: false,
      depoAmt: null,
      minDepo: 150,
      totalBonus: 225
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.reset()
      }else{
        this.checkProgress()
      }
    }
  },
  mounted(){
    if(this.isLoggedIn){
      this.checkProgress()
    }
    
  },
  methods:{
    checkProgress(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/dailyCheckin", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.progress = response.data.progress
              const info = response.data.info
              if(info.length > 0){
                this.todayCheckin = info[0]?.is_check_in_today ? true : false;
                this.chkinDate = info[0]?.last_check_in_date ?? null
                this.accuReward = info[0]?.accumulate_bonus_amount ?? null
                this.minDepo = info[0]?.min_deposit_amount ?? 150
                this.totalBonus = info[0]?.total_bonus_amount ?? 225
              }
              if(this.progress.length > 0){
                // const firstNull = this.progress.findIndex(o => o.working_date === null);
                // this.chkinDate = firstNull > 0 ? this.progress[firstNull-1].working_date : null
                // this.accuReward = this.progress.reduce((sum, o) => {
                //   if (o.working_date != null) {
                //     const n = Number(o.bonus_amount) || 0;
                //     return sum + n;
                //   }
                //   return sum;
                // }, 0);

                const infoToday = this.progress.find(o =>
                  o.working_date && this.$moment(o.working_date).isSame(this.$moment(), 'day')
                );
                // this.todayCheckin = infoToday?.working_date ? true : false;
                this.depoAmt = infoToday?.deposit_amount ?? null
                // this.todayCheckin = this.progress.some(o =>
                //   o.working_date && this.$moment(o.working_date).isSame(this.$moment(), 'day')
                // );
              }
              this.startRender = false
            } else {
              this.startRender = false
              this.goDepo = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
            this.goDepo = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    openReward(){
      if(this.sessionToken){
        this.showReward = true
      }else{
        this.$router.push('/login').catch(err => {})
      }
    },
    openPop(option, amt){
      if(this.sessionToken){
        if(option == 0){
          this.showGuide = true
        }
        if(option == 1){
          this.rewardAmt = amt
          // this.showReward = true
          this.showGuide = true
        }
      }else{
        this.$router.push('/login').catch(err => {})
      }
      
    },
    toInbox(){
      if(this.sessionToken){
        this.$router.push("/inbox").catch(error =>{})
      }else{
        this.showReward = false
        this.$router.push('/login').catch(err => {})
      }
    },
    toDepo(){
      if(this.sessionToken){
        this.$router.push("/deposit").catch(error =>{})
      }else{
        this.showGuide = false
        this.$router.push('/login').catch(err => {})
      }
    },
    toggleGuide(){
      this.showGuide = false
    },
    toggleReward(){
      this.showReward = false
    },
    reset(){
      this.chkinDate = null
      this.rewardAmt = null
      this.accuReward= null
      this.todayCheckin= false
      this.showGuide = false
      this.depoAmt = null
    }
  }
}
</script>
<style lang="css" scoped>
/* * {
  box-sizing: border-box;
  padding: 0;
  margin: 0; 
  font-family: sans-serif;
}*/

main {
  max-width: 400px;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: sans-serif;
}

main .signin-record-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

main .signin-record-div div:not(.divider) {
  padding: 1rem 2rem;
  font-size: 18px;
  text-align: center;
  font-weight: 550;
  color: rgb(190, 186, 186);
}

main .signin-record-div .divider {
  width: 2px;
  height: 50px;
  background-color: rgb(190, 186, 186);
}

main .signin-record-div .last-signin p:first-child {
  color: blue;
}

main .signin-record-div .total-signin-bonus p:first-child {
  color: rgb(226, 89, 89);
}

main .weekly-reward-div {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 1rem;
}

main .weekly-reward-div img {
  width: 100px;
}

main .weekly-reward-div .content {
  font-weight: 550;
}

main .weekly-reward-div .content .first-content {
  color: rgb(226, 89, 89);
}

main .weekly-reward-div .content-div {
  display: flex;
  align-items: center;
  gap: 10px;
}

main .weekly-reward-div .content .content-div .second-content {
  color: rgb(146, 36, 36);
}

main .weekly-reward-div .content .tooltipc {
  background-color: rgb(146, 36, 36);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: white;
}

.tooltipc:hover {
  cursor: pointer;
}

main .min-deposit-div {
  padding: 1rem;
  background-color: rgb(255, 243, 228);
  margin-bottom: 1rem;
  font-weight: 550;
}

main .min-deposit-div span {
  color: rgb(226, 89, 89);
}

main .angpao-div {
  display: grid;
  place-items: center;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem 0;
}

main .angpao-div .angpao-versions img {
  width: 100px;
}

main .angpao-div .angpao-versions img.opened {
  /* display: none; */
}

main .angpao-div .angpao-versions img:hover {
  cursor: pointer;
}

main .popup-div {
  display: none;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  inset: 0;
  /* display: grid; */
  place-items: center;
}

main .popup-div .popup-contents {
  text-align: center;
  position: relative;
}

main .confirmation-popup-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  inset: 0;
  /* display: grid; */
  display: none;
  place-items: center;
  padding: 0 1rem;
}

main .confirmation-popup-div .popup-contents {
  background-color: rgb(255, 243, 228);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 15px;
  padding: 2rem;
  /* height: 300px; */
  font-size: 18px;
  width: 368px;
}

main .confirmation-popup-div .popup-contents h3 {
  color: rgb(197, 50, 50);
}

main .popup-div .popup-contents img {
  width: 70%;
}

main .popup-div .popup-contents .popup-click {
  position: absolute;
  bottom: 3rem;
  left: 35%;
  width: 120px;
  height: 40px;
  cursor: pointer;
}

main .confirmation-popup-div .actions {
  display: flex;
  gap: 1rem;
}

button {
  cursor: pointer;
  outline: none;
  border: none;
  padding: 10px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 18px;
  width: 120px;
}

button.cancel {
  background: linear-gradient(to bottom, red, rgb(223, 2, 2));
  color: white;
}

button.go {
  background: linear-gradient(to bottom, yellow, rgb(234, 234, 14));
  color: red;
}


@media(max-width: 767px){
  .content-wrap{
    font-size: initial;
  }
}

</style>